<template>
<div class="lists pl-0 py-1  mr-2" >
<div class="box-left ">
     <p class="mr-3" >  {{ segnalazione.contenuto }}</p>
      <!--i > - {{segnalazione.nominativo }} </i-->
      <small >- {{ convertToUtc(date)}} - </small>
      </div>
 <div class="box-right align-self-end mb-2">
  <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on">
              <span class="item-dot" :stato="status" id="item-dot" ></span>
          </div>
        </template>
        <span class="textd" :stato="status"> </span>
      </v-tooltip>
</div></div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'card-segnalazione',
  props: {
    segnalazione: Object
  },
  data () {
    return {
      date: this.segnalazione.lastUpdate,
      status: this.segnalazione.stato

    }
  },

  methods: {
    convertToUtc (date) {
      return moment(this.segnalazione.lastUpdate).utc().format('DD/MM/YYYY')
    }

  }
}
</script>
